module.exports = __webpack_public_path__ + "static/img/rank_all_baowen.6219e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_all_baowen.png
// module id = woN5
// module chunks = 0